import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopbarStateService {

  public stateObs: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  constructor() {
    this.stateObs = new BehaviorSubject<boolean>(this._state);
  }
  private _state: boolean;

  public set state(v: boolean) {
    this._state = v;
    this.stateObs.next(v);
  }



}
